import React, { useEffect, useCallback, useRef } from 'react';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import { setVatDetails, getVatDetails } from '../Actions/Vat.action';

const ShowVat = ({ isMobile }) => {
  const dispatch = useDispatch();
  const firstRender = useRef(true);
  const vat = useSelector((state) => state.vat) || {};
  const setIsActive = useCallback((includeVATVal) => {
    dispatch(setVatDetails(includeVATVal)).then(() => {
      document.location.reload(true);
    });
  }, []);
  useEffect(() => {
    if (!firstRender.current) {
      return;
    }
    firstRender.current = false;
    if (!isMobile) dispatch(getVatDetails());
  }, []);

  const openVatList = (event) => {
    event.target.parentNode.classList.toggle('header__show-vat-select--open');
  };

  return (
    vat.isLoaded && (
      <div className="header__show-vat">
        <div>
          <ul className="header__show-vat-select">
            <li
              className={`header__show-vat-select-item ${
                vat.includeVAT ? ' header__show-vat-select-item--active' : ''
              }`}
              onClick={(e) =>
                !vat.includeVAT ? setIsActive(true) : openVatList(e)
              } // () => false
            >
              {translate('price.includevat')}
            </li>
            <li
              className={`header__show-vat-select-item${
                !vat.includeVAT ? ' header__show-vat-select-item--active' : ''
              }`}
              onClick={(e) =>
                vat.includeVAT ? setIsActive(false) : openVatList(e)
              }
            >
              {translate('price.excludevat')}
            </li>
          </ul>
        </div>
      </div>
    )
  );
};
export default ShowVat;
